__turbopack_context__.v({
  "container": "CardInstallation-module-scss-module__UMuFRq__container",
});
